<template>

  <div>

    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>
    <ConfirmPlanChangeDialog v-model="showConfirmDialog" :payment-info="payment_info" :plan="planToConfirm" :on-close="onPlanChanged"></ConfirmPlanChangeDialog>
    <v-dialog v-model="show" max-width="600px">
      <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

      <v-card color="#f0f0f0">
        <v-card-title>
          <h2>Manage Plan</h2>
          <v-spacer></v-spacer>
          <v-btn flat icon color="itoviGrayMid" @click="show=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0" v-if="plan.can_change_plan">




          <h3 class="text-xs-left mb-2">Current Plan:</h3>
          <v-card class="mx-auto">
            <v-card-text class="text-xs-left">

              <div class="mb-1 plan-title">{{ plan.name }}</div>

              <v-divider class="mt-2 mb-2"></v-divider>

              <div class="mb-2">{{ plan.details.description }}</div>

              <v-layout align-center row wrap>
                <span class="txt-bold">Monthly:&nbsp;</span>
                <span class="txt-bold">${{ formatPrice(plan.monthly) }}</span>
                <span class="txt-bold"
                      style="font-size: 7pt;">&nbsp;/ mo</span>
              </v-layout>




              <!--      what's included section          -->
              <div v-if="!!plan.details.included && plan.details.included.length > 0" class="mt-2">
<!--                <h4>What's included:</h4>-->
                <ul>
                  <template v-for="(updradeDetailsIncludedItem, index2) in plan.details.included">
                    <li :key="index2">{{ updradeDetailsIncludedItem }}</li>
                  </template>
                </ul>
              </div>

            </v-card-text>
          </v-card>

          <h3 v-if="plan.upgradeable_plans.length > 0" class="text-xs-left mt-4">Available Plans:</h3>
          <template v-for="(item, index) in plan.upgradeable_plans">


            <v-card :key="index" class="mx-auto mt-2" >

              <v-card-text class="text-xs-left">

                <div class="mb-1 plan-title">{{ item.name }}</div>

                <v-divider class="mt-2 mb-2"></v-divider>

                <div class="mb-2">{{ item.description }}</div>

                <v-layout align-center row wrap>
                  <span class="txt-bold">Price:&nbsp;</span>
                  <span class="txt-bold">${{ formatPrice(item.price) }}</span>
                </v-layout>
                <v-layout align-center row wrap>
                  <span class="txt-bold">Monthly:&nbsp;</span>
                  <span class="txt-bold">${{ formatPrice(item.monthly) }}</span>
                  <span class="txt-bold"
                        style="font-size: 7pt;">&nbsp;/ mo</span>
                </v-layout>




                <!--      what's included section          -->
                <div v-if="!!item.included && item.included.length > 0" class="mt-2">
<!--                  <h4>What's included:</h4>-->
                  <ul>
                    <template v-for="(updradeDetailsIncludedItem, index2) in item.included">
                      <li :key="index2">{{ updradeDetailsIncludedItem }}</li>
                    </template>
                  </ul>
                </div>

                <v-layout justify-center wrap class="mt-2">
                  <v-btn v-if="!is_mobile_app_webview" round color="primary" @click="showConfirmPlanChangeDialog(item)">Change plan to {{ item.name }}</v-btn>
                  <div class="text-xs-center" v-if="is_mobile_app_webview" >Log in to your iTOVi dashboard from a web browser to change your plan to <b>{{ item.name }}</b></div>
                </v-layout>

              </v-card-text>



            </v-card>

          </template>


        </v-card-text>

        <v-card-text class="pt-0" v-else>
          <v-card class="mx-auto mt-2" >
              <v-card-text class="text-xs-left">
                  To reactivate your account, please contact our customer support team:<br><br>
                  877-483-3748<br>
                  support@itovi.com<br><br>
                  MONDAY – FRIDAY<br>
                  8am ~ 6pm (MST)<br>
                  SATURDAY<br>
                  10am ~ 5pm (MST)
              </v-card-text>
          </v-card>
        </v-card-text>

      </v-card>
    </v-dialog>
  </div>

</template>

<style lang="scss" scoped>
  .plan-title {
    font-size: 15pt;
    color: #027689;
  }
</style>

<script>
  import store from "../../../store"
  import LoadingDialog from "../../LoadingDialog"
  import ConfirmPlanChangeDialog from "./ConfirmChangePlanDialog"

  export default {
    components: {
      LoadingDialog,
      ConfirmPlanChangeDialog
    },
    data: ()=> ({
      planToConfirm: null,
      showConfirmDialog: false,
      payment_info: store.state.ccInfo,
      is_mobile_app_webview: store.state.isMobileAppWebview,
      showLoadingDialog: false,
      snackbar: {
        success: false,
        error: false,
        timeout: 1500,
        errorMessage: "An unknown error occurred",
        successMessage: "Address updated successfully"
      },
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      plan: {
        type: Object,
        default: () => ({// this could be "On Hold" - in which case one of their "Upgradeable Plans" is their actual plan (like Basic)
          name: '',
          monthly: null,
          details: {
            included: [],
            description: null,
          },
          upgradeable_plans: [
            {
              id: 0,
              name: '',
              price: 0,
              monthly: 0,
              details: {
                included: [],
                description: null,
              }
            },
          ],
        })
      },
    },
    methods: {
      onPlanChanged(success) {
        if (success) {
          this.show = false
        }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async showConfirmPlanChangeDialog(plan) {
        // console.log(plan)
        // the the payment info so we can tell the user what card they are paying with
        this.payment_info = store.state.ccInfo
        this.planToConfirm = plan
        this.showConfirmDialog = true
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
